import { useSelector } from 'react-redux'
import {
  selectBaseColor,
  selectBgColor,
  selectFontColor,
  selectHeaderColor,
  selectIconColor,
  selectOpacity,
} from '../slices/settingSlice'

const useRootColor = () => {
  const baseColor = useSelector(selectBaseColor)
  const iconColor = useSelector(selectIconColor)
  const bgColor = useSelector(selectBgColor)
  const headerColor = useSelector(selectHeaderColor)
  const opacity = useSelector(selectOpacity)
  const fontColor = useSelector(selectFontColor)

  return { baseColor, iconColor, bgColor, headerColor, opacity, fontColor }
}

export default useRootColor
